import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import TextInput from "../reusableComponents/components/generics/TextInput";
// import Checkbox from "@mui/material/Checkbox";
import { Form, Field } from "react-final-form";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { verifyUserAndUpdatePassword } from "../action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  FORGOT_PASSWORD,
  HOME_PAGE,
  POLICY_HOLDER,
  PORTAL_INSUREE,
  PORTAL,
} from "../utils/constant";
// import { decodeId } from "../utils/helper";
// import ReCAPTCHA from "react-google-recaptcha";
import { useLocation } from "react-router-dom";

const Content = styled(Typography)({
  color: "#00913E",
});
const GridPadding = styled(Grid)({
  marginTop: "2rem",
});
const CheckBoxStyle = styled(Grid)({
  marginTop: "2rem",
});

function UpdatePasswordForm() {
  // const [loginToken, setLoginToken] = useState();
  // const [showPassword, setShowPassword] = useState(false);
  const { pathname, search } = useLocation();
  // const [checked, setChecked] = useState(false);
  // const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  // const [recaptchaKey, setRecaptchaKey] = useState(0);
  const formRef = useRef(null);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useState({
    user_id: "",
    token: "",
    username: "",
  });

  // const SignInSuccess = useSelector((state) => state);
  const userVerificationSuccess = useSelector(
    (state) => state?.profileReducer?.userVerificationSuccess
  );

  const userVerificationError = useSelector(
    (state) => state?.profileReducer?.userVerificationError
  );

  const loginError = useSelector((state) => state?.profileReducer?.errorLogin);
  let token;

  const handleVerification = async (password) => {
    dispatch(verifyUserAndUpdatePassword({ ...params, password }));
  };
  const onSubmit = async (values, event) => {
    // check password and confirm password
    if (values.password !== values.confirmPassword) {
      console.log("Password and Confirm Password do not match");
      return;
    }

    // check sql injection
    if (values.password.includes("'") || values.password.includes(";")) {
      console.log("Password contains SQL injection");
      return;
    }

    await handleVerification(values.password);

    // const respone = await dispatch(login(values));
  };

  useEffect(() => {
    if (userVerificationSuccess) {
      navigate(PORTAL);
    }
  }, [userVerificationSuccess]);

  useEffect(() => {
    if (userVerificationError) {
      console.log("====> userVerificationError", userVerificationError);
    }
  }, [userVerificationError]);

  const validate = (values) => {
    const errors = {};
    if (!values.userName) {
      errors.userName = t("UserName is required");
    }
    if (!values.password) {
      errors.password = t("Password is required");
    }
    return errors;
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(search);
    const userId = urlParams.get("user_id");
    const token = urlParams.get("token");
    const username = urlParams.get("username");

    setParams({
      user_id: userId,
      token: token,
      username: username,
    });
  }, [search]);

  return (
    <Grid item xs={12} className="sign-in-input">
      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        {t("adminManagement.VerifyAccountSetNewPassword")}
      </Typography>
      <Grid container>
        <Form
          onSubmit={onSubmit}
          validate={validate}
          initialValues={{
            userName: params.username,
          }}
          render={({
            handleSubmit,
            form,
            submitting,
            pristine,
            values,
            errors,
          }) => {
            formRef.current = form;
            return (
              <Grid item xs={12}>
                <form
                  onSubmit={handleSubmit}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSubmit(e);
                    }
                  }}
                >
                  <Grid item xs={12}>
                    <GridPadding>
                      <Field
                        name="userName"
                        component={TextInput}
                        label={t("User Name")}
                        type="text"
                        disabled={true}
                        required={true}
                        error={errors.userName}
                        placeholder={t("Please Enter UserName")}
                      />
                    </GridPadding>
                  </Grid>
                  <Grid item xs={12}>
                    <GridPadding>
                      <Field
                        name="password"
                        component={TextInput}
                        label={t("Password")}
                        required={true}
                        error={errors.password}
                        placeholder={t("Please Enter Your Password")}
                        password={"password"}
                      />
                    </GridPadding>
                  </Grid>

                  <Grid item xs={12}>
                    <GridPadding>
                      <Field
                        name="confirmPassword"
                        component={TextInput}
                        label={t("Confirm Password")}
                        required={true}
                        error={errors.confirmPassword}
                        placeholder={t("Please Enter Your Password")}
                        password={"password"}
                      />
                    </GridPadding>
                  </Grid>

                  <Button
                    variant="contained"
                    fullWidth
                    style={{ marginTop: "2rem" }}
                    type="submit"
                    disabled={
                      submitting || pristine || Object.keys(errors).length > 0
                    }
                  >
                    {t("adminManagement.save")}
                  </Button>
                </form>
              </Grid>
            );
          }}
        />
        {loginError || userVerificationError ? (
          <Typography
            color="red"
            fontSize={"1rem"}
            margin={"0 auto"}
            marginTop={"1rem"}
          >
            {userVerificationError || t("Please Enter Valid Credential !")}
          </Typography>
        ) : (
          ""
        )}
      </Grid>
    </Grid>
  );
}

export default UpdatePasswordForm;
